import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationNone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAnimationNone"><Path d="M20.5 3.5H12V20.5H3.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAnimationNone;
